// extracted by mini-css-extract-plugin
export default {"textWrapper":"TradesCard_textWrapper__oxr5S","summaryText":"TradesCard_summaryText__HM1Do","underlineText":"TradesCard_underlineText__VA82S"};